// extracted by mini-css-extract-plugin
export default {"left":"styles-module__left__src-labstep-web-components-EntityStateWorkflow-Modal-LeftPanel-_gdGnK"};